// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"reset-button_wrapper__NKHuS"};